import type { IconNode } from '../types';

/**
 * @name letter-r
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTAgMTIgOCA4IiAvPgogIDxwYXRoIGQ9Ik02IDEyaDhhNCA0IDAgMDAwLThIN2ExIDEgMCAwMC0xIDF2MTUiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/letter-r
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const LetterR: IconNode = [
  ['path', { d: 'm10 12 8 8' }],
  ['path', { d: 'M6 12h8a4 4 0 000-8H7a1 1 0 00-1 1v15' }],
];

export default LetterR;
